import { render, staticRenderFns } from "./infoModal.vue?vue&type=template&id=4d8ceefe&scoped=true&"
import script from "./infoModal.vue?vue&type=script&lang=js&"
export * from "./infoModal.vue?vue&type=script&lang=js&"
import style0 from "./infoModal.vue?vue&type=style&index=0&id=4d8ceefe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8ceefe",
  null
  
)

export default component.exports